import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "content"];

/** @jsx jsx */
import { css, jsx, useTheme } from '@emotion/react';
import React from 'react';

var BreadcrumbsItem = function BreadcrumbsItem(_ref) {
  var children = _ref.children,
      content = _ref.content,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var _useTheme = useTheme(),
      direction = _useTheme.direction;

  var rootStyles = /*#__PURE__*/css({
    position: 'relative',
    display: 'block',
    margin: '0',
    padding: 0,
    paddingLeft: direction === 'ltr' ? '11px' : '14px',
    paddingRight: direction === 'rtl' ? '11px' : '14px',
    paddingInlineStart: '11px',
    paddingInlineEnd: '14px',
    '&:first-child': {
      paddingInlineStart: '0'
    },
    '&:after': {
      position: 'absolute',
      right: direction === 'ltr' ? '0' : undefined,
      left: direction === 'rtl' ? '0' : undefined,
      top: '50%',
      fontSize: '12px',
      transform: 'translateY(-50%)',
      zIndex: 1
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0JyZWFkY3J1bWJzSXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0JxQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9CcmVhZGNydW1ic0l0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5cbmltcG9ydCB7IGNzcywganN4LCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbnR5cGUgT3duUHJvcHMgPSB7XG4gIGNoaWxkcmVuPzogUmVhY3QuUmVhY3ROb2RlO1xuICBjb250ZW50PzogUmVhY3QuUmVhY3ROb2RlO1xufTtcblxudHlwZSBVbmhhbmRsZWRQcm9wcyA9IE9taXQ8XG4gIFJlYWN0LkhUTUxBdHRyaWJ1dGVzPEhUTUxMSUVsZW1lbnQ+LFxuICBrZXlvZiBPd25Qcm9wc1xuPjtcblxudHlwZSBQcm9wcyA9IE93blByb3BzICYgVW5oYW5kbGVkUHJvcHM7XG5cbmNvbnN0IEJyZWFkY3J1bWJzSXRlbTogUmVhY3QuRkM8UHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIGNvbnRlbnQsXG4gIC4uLnVuaGFuZGxlZFByb3BzXG59KSA9PiB7XG4gIGNvbnN0IHsgZGlyZWN0aW9uIH0gPSB1c2VUaGVtZSgpO1xuXG4gIGNvbnN0IHJvb3RTdHlsZXMgPSBjc3Moe1xuICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgIGRpc3BsYXk6ICdibG9jaycsXG4gICAgbWFyZ2luOiAnMCcsXG4gICAgcGFkZGluZzogMCxcbiAgICBwYWRkaW5nTGVmdDogZGlyZWN0aW9uID09PSAnbHRyJyA/ICcxMXB4JyA6ICcxNHB4JyxcbiAgICBwYWRkaW5nUmlnaHQ6IGRpcmVjdGlvbiA9PT0gJ3J0bCcgPyAnMTFweCcgOiAnMTRweCcsXG4gICAgcGFkZGluZ0lubGluZVN0YXJ0OiAnMTFweCcsXG4gICAgcGFkZGluZ0lubGluZUVuZDogJzE0cHgnLFxuICAgICcmOmZpcnN0LWNoaWxkJzoge1xuICAgICAgcGFkZGluZ0lubGluZVN0YXJ0OiAnMCcsXG4gICAgfSxcbiAgICAnJjphZnRlcic6IHtcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgcmlnaHQ6IGRpcmVjdGlvbiA9PT0gJ2x0cicgPyAnMCcgOiB1bmRlZmluZWQsXG4gICAgICBsZWZ0OiBkaXJlY3Rpb24gPT09ICdydGwnID8gJzAnIDogdW5kZWZpbmVkLFxuICAgICAgdG9wOiAnNTAlJyxcbiAgICAgIGZvbnRTaXplOiAnMTJweCcsXG4gICAgICB0cmFuc2Zvcm06ICd0cmFuc2xhdGVZKC01MCUpJyxcbiAgICAgIHpJbmRleDogMSxcbiAgICB9LFxuICB9KTtcblxuICByZXR1cm4gKFxuICAgIDxsaSB7Li4udW5oYW5kbGVkUHJvcHN9IGNzcz17cm9vdFN0eWxlc30+XG4gICAgICB7Y2hpbGRyZW4gIT0gbnVsbCA/IGNoaWxkcmVuIDogY29udGVudH1cbiAgICA8L2xpPlxuICApO1xufTtcblxuQnJlYWRjcnVtYnNJdGVtLmRpc3BsYXlOYW1lID0gJ0JyZWFkY3J1bWJzSXRlbSc7XG5cbmV4cG9ydCBkZWZhdWx0IEJyZWFkY3J1bWJzSXRlbTtcbiJdfQ== */");
  return jsx("li", _extends({}, unhandledProps, {
    css: rootStyles
  }), children != null ? children : content);
};

BreadcrumbsItem.displayName = 'BreadcrumbsItem';
export default BreadcrumbsItem;